import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useNavigate } from '@/js/libs/router';

import { useCompanySwitchContext } from 'src/modules/CompaniesSwitch/context.tsx';
import { usePostLogoutCallback } from 'src/modules/PostCampaign/index.ts';

const useLogoutCallback = () => {
  const navigate = useNavigate();
  const { onCompanyChange } = useCompanySwitchContext();

  const generalLogoutCallback = useCallbackRef(() => navigate('/'));
  const postLogoutCallback = usePostLogoutCallback();
  const callback = postLogoutCallback || generalLogoutCallback;

  return useCallbackRef(() => {
    callback?.();
    onCompanyChange(null);
  });
};

export default useLogoutCallback;
